export const mutations = {
  addProgramme (state, programme) {
    state.programme = programme
  },
  setProgramme (state, programme) {
    state.programme = programme
  },
    addProgrammes(state, programme){
    state.programmes = [ ...programme ]
  },
}
